// extracted by mini-css-extract-plugin
export default {"root":"AiChatOverlay_root__RXTdG","container":"AiChatOverlay_container__+YNO6"};